import { Section } from "@/components/layout/section/Section";
import ProductsShowCase from "@/components/product/ProductsShowCase";
import { Button } from "@/components/ui/button";
import type { ProductWithAccuratePricingData } from "@/hooks";
import { useSaleProducts } from "@/queries/products";
import { useSellersMap } from "@/queries/sellers";
import { mergedStatus } from "@/queries/utils";
import { getRandom } from "@/utils/random";
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { useMemo } from "react";

export function LimitedTimeOffers() {
  const saleProductsQuery = useSaleProducts();
  const sellersQuery = useSellersMap();
  const { data: sale } = saleProductsQuery;

  const randomSelection = useMemo(() => {
    if (!sale?.products) {
      return [];
    }
    return getRandom(sale.products, 4).map(
      (item) =>
        ({
          ...item,
          status: "published" // products-sale endpoint always returns only active products
        }) satisfies ProductWithAccuratePricingData
    );
  }, [sale?.products]);

  const { status } = mergedStatus([saleProductsQuery, sellersQuery]);

  return (
    <Section
      title="Limited Time Offers"
      description="Exclusive deals available for a short time - grab them before they're gone!"
      rightContent={
        <Button variant="outline" asChild>
          <Link to="/search" search={{ sale: true }}>
            See All Offers
            <ChevronRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      }
    >
      <ProductsShowCase
        //
        status={status}
        items={randomSelection}
        pricingStatus="success" // API already returns resolved pricing
      />
    </Section>
  );
}
